// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#probation-page.probation-page {
  font-family: "Open Sans", sans-serif;
  background: #f9fafb;
  color: #111827;
  min-height: calc(100vh - 24px);
  width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
  position: relative;
}

.probation-header-bar {
  background: #024f42;
  color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.probation-header-inner {
  width: 100%;
  max-width: 1320px;
  margin: 0 auto;
  padding: 16px 0px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-sizing: border-box;
}

.probation-header-inner h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.probation-logo {
  height: 32px;
  width: auto;
}

.probation-main {
  max-width: none;
  width: 100%;
  margin: 0;
  padding: 24px;
  box-sizing: border-box;
}

.probation-form {
  width: 100%;
  max-width: 1320px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.probation-form h2 {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 12px;
}

.probation-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.probation-grid-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  margin-top: 20px;
}

.input-label {
  display: block;
  font-size: 14px;
  line-height: 1.3;
  margin-bottom: 8px;
  color: #374151;
}

.input-icon-wrap {
  display: flex;
  align-items: center;
  height: 44px;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0 12px;
  box-sizing: border-box;
}

.icon-left {
  color: #6b7280;
  margin-right: 8px;
  font-size: 20px;
}

.probation-page input,
.probation-page textarea,
.custom-select {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  min-height: 42px;
  border: 1px solid #cbd5e1 !important;
  border-radius: 6px;
  background: #fff !important;
  color: #111827 !important;
  padding: 8px 34px 8px 10px;
  line-height: 1.2;
  cursor: pointer;
  box-sizing: border-box;
}

.input-icon-wrap input {
  height: 100%;
  margin: 0 !important;
  border: 0;
  border-bottom: 0 !important;
  border-radius: 0;
  padding: 0;
  line-height: normal;
  box-shadow: none !important;
}

.probation-page input:focus,
.probation-page textarea:focus,
.custom-select:focus {
  outline: none;
  border-color: #66bfa1 !important;
  box-shadow: 0 0 0 1px #66bfa1 !important;
}

.probation-loading {
  font-size: 12px;
  color: #6b7280;
  margin-top: 8px;
}
.probation-warning {
  font-size: 12px;
  color: #dc2626;
  margin-top: 8px;
}

.probation-input-error {
  border-color: #dc2626 !important;
  box-shadow: 0 0 0 1px #dc2626 !important;
}

.probation-table-wrap-error {
  border-color: #dc2626;
}

.probation-page-loading {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(249, 250, 251, 0.78);
  backdrop-filter: blur(1px);
}

.probation-page-loading-card {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  color: #111827;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.probation-page-spinner {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #cbd5e1;
  border-top-color: #0f9d6e;
  animation: probation-spin 0.8s linear infinite;
}

@keyframes probation-spin {
  to {
    transform: rotate(360deg);
  }
}

.probation-table-wrap {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
}

.probation-table {
  width: 100%;
  min-width: 1020px;
  border-collapse: collapse;
}

.probation-table th,
.probation-table td {
  border: 1px solid #e5e7eb;
  padding: 8px;
  vertical-align: top;
}

.probation-table th {
  background: #66bfa1;
  color: #000;
  text-align: left;
  font-size: 14px;
  font-weight: 600;
}

.probation-table td:nth-child(1) {
  width: 44px;
}

.probation-table td:nth-child(2) {
  width: 190px;
}

.probation-table td:nth-child(3) {
  width: 340px;
}

.probation-table td:nth-child(4) {
  width: 170px;
}

.probation-table td:nth-child(5) {
  width: 230px;
}

.def-text {
  font-size: 14px;
  color: #111827;
}

.probation-role-wrap {
  margin-top: 0px;
}

.probation-label-mini {
  font-size: 14px;
  color: #4b5563;
  margin-bottom: 6px;
}

.custom-select-wrapper {
  position: relative;
}

.custom-select {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  min-height: 42px;
  border: 1px solid #cbd5e1 !important;
  border-radius: 6px;
  background: #fff !important;
  color: #111827 !important;
  padding: 8px 34px 8px 10px;
  line-height: 1.2;
  cursor: pointer;
  box-sizing: border-box;
}

.custom-select-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #4b5563;
  pointer-events: none;
}

.custom-select-icon svg {
  width: 16px;
  height: 16px;
}

.probation-result-box {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  padding: 12px 16px;
  min-height: 96px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.result-title {
  font-size: 14px;
  color: #374151;
  margin: 0;
  line-height: 1.35;
}

.result-yes,
.result-no {
  margin: 2px 0 0;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 1.35;
}

.result-yes {
  color: #059669 !important;
}

.result-no {
  color: #dc2626 !important;
}

.toggle-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.probation-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.probation-icon-wrap svg {
  width: 18px;
  height: 18px;
}

.probation-icon-check {
  color: #16a34a;
}

.probation-icon-cross {
  color: #dc2626;
}

.probation-toggle-pill {
  position: relative;
  width: 46px;
  height: 26px;
}

.probation-toggle-pill input {
  position: absolute;
  inset: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  border: 0 !important;
  box-shadow: none !important;
  outline: none !important;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  z-index: 2;
}

.probation-toggle-pill .slider {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: auto !important;
  bottom: auto !important;
  width: 46px !important;
  height: 26px !important;
  display: block;
  border-radius: 999px;
  background: #d1d5db;
  transition: 0.2s ease;
}

.probation-toggle-pill .slider:before {
  content: "";
  position: absolute;
  left: 4px;
  top: 4px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 0;
  background: #fff;
  transition: 0.2s ease;
}

.probation-toggle-pill input:checked + .slider {
  background: #0d9b6f;
}

.probation-toggle-pill input:checked + .slider:before {
  transform: translateX(20px);
}

.probation-ack {
  background: #f3f4f6;
  padding: 24px;
  border-radius: 6px;
}

.probation-ack label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 4px;
}

.probation-ack input {
  background: transparent;
  border: 0;
  padding: 0;
  font-size: 14px;
}

.probation-submit-wrap {
  text-align: center;
  padding: 8px 0 16px;
}

.btn-exo {
  background: #80b157;
  color: #fff;
  border: 0;
  border-radius: 9999px;
  padding: 8px 18px;
  font-weight: 700;
  cursor: pointer;
}

.btn-exo:hover:not(:disabled) {
  background: #024f42;
}

.btn-exo:active:not(:disabled) {
  background: #003e35;
}

.btn-exo:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .probation-grid-2,
  .probation-grid-3 {
    grid-template-columns: 1fr;
    margin-top: 20px;
  }

  .probation-header-inner h1 {
    font-size: 20px;
  }
}





#probation-page .input-icon-wrap input.browser-default,
#probation-page .input-icon-wrap input.browser-default:focus,
#probation-page .input-icon-wrap input.browser-default:active {
  margin: 0 !important;
  border: 0 !important;
  border-bottom: 0 !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  outline: none !important;
}



.probation-additional-textarea {
  width: 100%;
  height: 95px !important;
  min-height: 95px !important;
  border: 1px solid #b8c2cc !important;
  border-radius: 6px;
  background: #fff;
  padding: 10px;
  font-size: 14px;
  color: #111827;
  line-height: 1.4;
  resize: none;
  box-sizing: border-box;
}

.probation-additional-textarea:focus {
  outline: none;
  border-color: #0d9b6f !important;
  box-shadow: 0 0 0 1px rgba(13, 155, 111, 0.15) !important;
}







.probation-toggle-pill input:focus + .slider {
  box-shadow: none;
}






#probation-page .probation-ack input,
#probation-page .probation-ack input:focus,
#probation-page .probation-ack input:active {
  border: 0 !important;
  border-bottom: 0 !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  outline: none !important;
}

.probation-ack-value {
  margin: 0;
  font-size: 14px;
  color: #111827;
  line-height: 1.4;
}


.probation-training-textarea {
  width: 100%;
  height: 96px !important;
  min-height: 96px !important;
  border: 1px solid #d1d5db !important;
  border-radius: 6px;
  background: #fff;
  padding: 8px;
  font-size: 14px;
  color: #111827;
  line-height: 1.4;
  resize: none;
  box-sizing: border-box;
}

.probation-training-textarea:focus {
  outline: none;
  border-color: #9ca3af !important;
  box-shadow: none !important;
}

.probation-comment-textarea {
  width: 100%;
  min-height: 60px;
  border: 1px solid #d1d5db !important;
  border-radius: 6px;
  background: #fff;
  padding: 8px;
  font-size: 14px;
  color: #111827;
  line-height: 1.4;
  resize: vertical;
  box-sizing: border-box;
}

.probation-comment-textarea:focus {
  outline: none;
  border-color: #9ca3af !important;
  box-shadow: none !important;
}


.custom-select.browser-default {
  display: block !important;
}












.probation-table th:nth-child(1),
.probation-table td:nth-child(1) {
  width: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding-left: 6px;
  padding-right: 6px;
}










.probation-table thead th {
  padding-top: 16px;
  padding-bottom: 16px;
}






.probation-dialog-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(17, 24, 39, 0.25);
}

.probation-dialog-card {
  width: min(560px, calc(100vw - 32px));
  background: #fff;
  border-radius: 10px;
  padding: 22px 24px 20px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.probation-dialog-title {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 700;
  color: #1f2937;
}

.probation-dialog-line {
  margin: 0;
  font-size: 14px;
  color: #1f2937;
}

.probation-dialog-line + .probation-dialog-line {
  margin-top: 6px;
}

.probation-dialog-spinner {
  display: inline-block;
  margin-top: 16px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 3px solid #cbd5e1;
  border-top-color: #4d6630;
  animation: probation-spin 0.8s linear infinite;
}

.probation-dialog-ok {
  margin-top: 18px;
  min-width: 64px;
  height: 34px;
  border: none;
  border-radius: 18px;
  background: #4d6630;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}



.probation-pdf-link {
  color: #0f9d6e;
  text-decoration: underline;
  font-weight: 600;
}


.probation-blocked {
  max-width: 1320px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #fecaca;
  color: #991b1b;
  border-radius: 8px;
  padding: 16px 18px;
  font-size: 14px;
}


`, "",{"version":3,"sources":["webpack://./src/components/Probation/style.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,8BAA8B;EAC9B,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;;EAGE,aAAa;EACb,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,wBAAwB;EACxB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;;;;;AAMA;;;EAGE,oBAAoB;EACpB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,wBAAwB;AAC1B;;;;AAIA;EACE,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,yDAAyD;AAC3D;;;;;;;;AAQA;EACE,gBAAgB;AAClB;;;;;;;AAOA;;;EAGE,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,2BAA2B;AAC7B;;;AAGA;EACE,yBAAyB;AAC3B;;;;;;;;;;;;;AAaA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;AACpB;;;;;;;;;;;AAWA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;;;;;;AAOA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;;;AAIA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;;AAGA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":["#probation-page.probation-page {\n  font-family: \"Open Sans\", sans-serif;\n  background: #f9fafb;\n  color: #111827;\n  min-height: calc(100vh - 24px);\n  width: 100vw;\n  margin-left: calc(50% - 50vw);\n  margin-right: calc(50% - 50vw);\n  position: relative;\n}\n\n.probation-header-bar {\n  background: #024f42;\n  color: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.probation-header-inner {\n  width: 100%;\n  max-width: 1320px;\n  margin: 0 auto;\n  padding: 16px 0px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-sizing: border-box;\n}\n\n.probation-header-inner h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.probation-logo {\n  height: 32px;\n  width: auto;\n}\n\n.probation-main {\n  max-width: none;\n  width: 100%;\n  margin: 0;\n  padding: 24px;\n  box-sizing: border-box;\n}\n\n.probation-form {\n  width: 100%;\n  max-width: 1320px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n.probation-form h2 {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0 0 12px;\n}\n\n.probation-grid-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.probation-grid-3 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 16px;\n  margin-top: 20px;\n}\n\n.input-label {\n  display: block;\n  font-size: 14px;\n  line-height: 1.3;\n  margin-bottom: 8px;\n  color: #374151;\n}\n\n.input-icon-wrap {\n  display: flex;\n  align-items: center;\n  height: 44px;\n  background: #fff;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 0 12px;\n  box-sizing: border-box;\n}\n\n.icon-left {\n  color: #6b7280;\n  margin-right: 8px;\n  font-size: 20px;\n}\n\n.probation-page input,\n.probation-page textarea,\n.custom-select {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 100%;\n  min-height: 42px;\n  border: 1px solid #cbd5e1 !important;\n  border-radius: 6px;\n  background: #fff !important;\n  color: #111827 !important;\n  padding: 8px 34px 8px 10px;\n  line-height: 1.2;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.input-icon-wrap input {\n  height: 100%;\n  margin: 0 !important;\n  border: 0;\n  border-bottom: 0 !important;\n  border-radius: 0;\n  padding: 0;\n  line-height: normal;\n  box-shadow: none !important;\n}\n\n.probation-page input:focus,\n.probation-page textarea:focus,\n.custom-select:focus {\n  outline: none;\n  border-color: #66bfa1 !important;\n  box-shadow: 0 0 0 1px #66bfa1 !important;\n}\n\n.probation-loading {\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: 8px;\n}\n.probation-warning {\n  font-size: 12px;\n  color: #dc2626;\n  margin-top: 8px;\n}\n\n.probation-input-error {\n  border-color: #dc2626 !important;\n  box-shadow: 0 0 0 1px #dc2626 !important;\n}\n\n.probation-table-wrap-error {\n  border-color: #dc2626;\n}\n\n.probation-page-loading {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(249, 250, 251, 0.78);\n  backdrop-filter: blur(1px);\n}\n\n.probation-page-loading-card {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  background: #ffffff;\n  color: #111827;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n}\n\n.probation-page-spinner {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid #cbd5e1;\n  border-top-color: #0f9d6e;\n  animation: probation-spin 0.8s linear infinite;\n}\n\n@keyframes probation-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.probation-table-wrap {\n  overflow-x: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #fff;\n}\n\n.probation-table {\n  width: 100%;\n  min-width: 1020px;\n  border-collapse: collapse;\n}\n\n.probation-table th,\n.probation-table td {\n  border: 1px solid #e5e7eb;\n  padding: 8px;\n  vertical-align: top;\n}\n\n.probation-table th {\n  background: #66bfa1;\n  color: #000;\n  text-align: left;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.probation-table td:nth-child(1) {\n  width: 44px;\n}\n\n.probation-table td:nth-child(2) {\n  width: 190px;\n}\n\n.probation-table td:nth-child(3) {\n  width: 340px;\n}\n\n.probation-table td:nth-child(4) {\n  width: 170px;\n}\n\n.probation-table td:nth-child(5) {\n  width: 230px;\n}\n\n.def-text {\n  font-size: 14px;\n  color: #111827;\n}\n\n.probation-role-wrap {\n  margin-top: 0px;\n}\n\n.probation-label-mini {\n  font-size: 14px;\n  color: #4b5563;\n  margin-bottom: 6px;\n}\n\n.custom-select-wrapper {\n  position: relative;\n}\n\n.custom-select {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 100%;\n  min-height: 42px;\n  border: 1px solid #cbd5e1 !important;\n  border-radius: 6px;\n  background: #fff !important;\n  color: #111827 !important;\n  padding: 8px 34px 8px 10px;\n  line-height: 1.2;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.custom-select-icon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #4b5563;\n  pointer-events: none;\n}\n\n.custom-select-icon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.probation-result-box {\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  padding: 12px 16px;\n  min-height: 96px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n}\n\n.result-title {\n  font-size: 14px;\n  color: #374151;\n  margin: 0;\n  line-height: 1.35;\n}\n\n.result-yes,\n.result-no {\n  margin: 2px 0 0;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  line-height: 1.35;\n}\n\n.result-yes {\n  color: #059669 !important;\n}\n\n.result-no {\n  color: #dc2626 !important;\n}\n\n.toggle-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.probation-icon-wrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.probation-icon-wrap svg {\n  width: 18px;\n  height: 18px;\n}\n\n.probation-icon-check {\n  color: #16a34a;\n}\n\n.probation-icon-cross {\n  color: #dc2626;\n}\n\n.probation-toggle-pill {\n  position: relative;\n  width: 46px;\n  height: 26px;\n}\n\n.probation-toggle-pill input {\n  position: absolute;\n  inset: 0;\n  margin: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  border: 0 !important;\n  box-shadow: none !important;\n  outline: none !important;\n  appearance: none;\n  -webkit-appearance: none;\n  cursor: pointer;\n  z-index: 2;\n}\n\n.probation-toggle-pill .slider {\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: auto !important;\n  bottom: auto !important;\n  width: 46px !important;\n  height: 26px !important;\n  display: block;\n  border-radius: 999px;\n  background: #d1d5db;\n  transition: 0.2s ease;\n}\n\n.probation-toggle-pill .slider:before {\n  content: \"\";\n  position: absolute;\n  left: 4px;\n  top: 4px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 0;\n  background: #fff;\n  transition: 0.2s ease;\n}\n\n.probation-toggle-pill input:checked + .slider {\n  background: #0d9b6f;\n}\n\n.probation-toggle-pill input:checked + .slider:before {\n  transform: translateX(20px);\n}\n\n.probation-ack {\n  background: #f3f4f6;\n  padding: 24px;\n  border-radius: 6px;\n}\n\n.probation-ack label {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: #6b7280;\n  margin-bottom: 4px;\n}\n\n.probation-ack input {\n  background: transparent;\n  border: 0;\n  padding: 0;\n  font-size: 14px;\n}\n\n.probation-submit-wrap {\n  text-align: center;\n  padding: 8px 0 16px;\n}\n\n.btn-exo {\n  background: #80b157;\n  color: #fff;\n  border: 0;\n  border-radius: 9999px;\n  padding: 8px 18px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.btn-exo:hover:not(:disabled) {\n  background: #024f42;\n}\n\n.btn-exo:active:not(:disabled) {\n  background: #003e35;\n}\n\n.btn-exo:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n@media (max-width: 900px) {\n  .probation-grid-2,\n  .probation-grid-3 {\n    grid-template-columns: 1fr;\n    margin-top: 20px;\n  }\n\n  .probation-header-inner h1 {\n    font-size: 20px;\n  }\n}\n\n\n\n\n\n#probation-page .input-icon-wrap input.browser-default,\n#probation-page .input-icon-wrap input.browser-default:focus,\n#probation-page .input-icon-wrap input.browser-default:active {\n  margin: 0 !important;\n  border: 0 !important;\n  border-bottom: 0 !important;\n  box-shadow: none !important;\n  -webkit-box-shadow: none !important;\n  outline: none !important;\n}\n\n\n\n.probation-additional-textarea {\n  width: 100%;\n  height: 95px !important;\n  min-height: 95px !important;\n  border: 1px solid #b8c2cc !important;\n  border-radius: 6px;\n  background: #fff;\n  padding: 10px;\n  font-size: 14px;\n  color: #111827;\n  line-height: 1.4;\n  resize: none;\n  box-sizing: border-box;\n}\n\n.probation-additional-textarea:focus {\n  outline: none;\n  border-color: #0d9b6f !important;\n  box-shadow: 0 0 0 1px rgba(13, 155, 111, 0.15) !important;\n}\n\n\n\n\n\n\n\n.probation-toggle-pill input:focus + .slider {\n  box-shadow: none;\n}\n\n\n\n\n\n\n#probation-page .probation-ack input,\n#probation-page .probation-ack input:focus,\n#probation-page .probation-ack input:active {\n  border: 0 !important;\n  border-bottom: 0 !important;\n  box-shadow: none !important;\n  -webkit-box-shadow: none !important;\n  outline: none !important;\n}\n\n.probation-ack-value {\n  margin: 0;\n  font-size: 14px;\n  color: #111827;\n  line-height: 1.4;\n}\n\n\n.probation-training-textarea {\n  width: 100%;\n  height: 96px !important;\n  min-height: 96px !important;\n  border: 1px solid #d1d5db !important;\n  border-radius: 6px;\n  background: #fff;\n  padding: 8px;\n  font-size: 14px;\n  color: #111827;\n  line-height: 1.4;\n  resize: none;\n  box-sizing: border-box;\n}\n\n.probation-training-textarea:focus {\n  outline: none;\n  border-color: #9ca3af !important;\n  box-shadow: none !important;\n}\n\n.probation-comment-textarea {\n  width: 100%;\n  min-height: 60px;\n  border: 1px solid #d1d5db !important;\n  border-radius: 6px;\n  background: #fff;\n  padding: 8px;\n  font-size: 14px;\n  color: #111827;\n  line-height: 1.4;\n  resize: vertical;\n  box-sizing: border-box;\n}\n\n.probation-comment-textarea:focus {\n  outline: none;\n  border-color: #9ca3af !important;\n  box-shadow: none !important;\n}\n\n\n.custom-select.browser-default {\n  display: block !important;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n.probation-table th:nth-child(1),\n.probation-table td:nth-child(1) {\n  width: 36px !important;\n  min-width: 36px !important;\n  max-width: 36px !important;\n  padding-left: 6px;\n  padding-right: 6px;\n}\n\n\n\n\n\n\n\n\n\n\n.probation-table thead th {\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n\n\n\n\n\n\n.probation-dialog-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(17, 24, 39, 0.25);\n}\n\n.probation-dialog-card {\n  width: min(560px, calc(100vw - 32px));\n  background: #fff;\n  border-radius: 10px;\n  padding: 22px 24px 20px;\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n\n.probation-dialog-title {\n  margin: 0 0 8px;\n  font-size: 22px;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.probation-dialog-line {\n  margin: 0;\n  font-size: 14px;\n  color: #1f2937;\n}\n\n.probation-dialog-line + .probation-dialog-line {\n  margin-top: 6px;\n}\n\n.probation-dialog-spinner {\n  display: inline-block;\n  margin-top: 16px;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 3px solid #cbd5e1;\n  border-top-color: #4d6630;\n  animation: probation-spin 0.8s linear infinite;\n}\n\n.probation-dialog-ok {\n  margin-top: 18px;\n  min-width: 64px;\n  height: 34px;\n  border: none;\n  border-radius: 18px;\n  background: #4d6630;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n\n\n.probation-pdf-link {\n  color: #0f9d6e;\n  text-decoration: underline;\n  font-weight: 600;\n}\n\n\n.probation-blocked {\n  max-width: 1320px;\n  margin: 0 auto;\n  background: #fff;\n  border: 1px solid #fecaca;\n  color: #991b1b;\n  border-radius: 8px;\n  padding: 16px 18px;\n  font-size: 14px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
